// src/services/attendanceService.js
import api from './api'

const AttendanceService = {
  // Get all attendance records
  getAllAttendance: async (params = {}) => {
    try {
      const queryString = new URLSearchParams(params).toString()
      const url = `/hr/attendance${queryString ? `?${queryString}` : ''}`
      
      console.log('Fetching attendance records from:', url)
      const response = await api.get(url)
      
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || 'Attendance records retrieved successfully'
      }
    } catch (error) {
      console.error('Error fetching attendance:', error)
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch attendance records',
        error: error.response?.data || error.message
      }
    }
  },

  // Get attendance by ID
  getAttendanceById: async (attendanceId) => {
    try {
      console.log('Fetching attendance by ID:', attendanceId)
      const response = await api.get(`/hr/attendance/${attendanceId}`)
      
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || 'Attendance record retrieved successfully'
      }
    } catch (error) {
      console.error('Error fetching attendance by ID:', error)
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch attendance record',
        error: error.response?.data || error.message
      }
    }
  },

  // Create new attendance record
  createAttendance: async (attendanceData) => {
    try {
      console.log('Creating attendance record:', attendanceData)
      
      // Format the data according to API requirements
      const payload = {
        employee: attendanceData.employee,
        date: attendanceData.date,
        ...(attendanceData.clockIn && { clockIn: attendanceData.clockIn }),
        ...(attendanceData.clockOut && { clockOut: attendanceData.clockOut }),
        ...(attendanceData.status && { status: attendanceData.status })
      }
      
      const response = await api.post('/hr/attendance', payload)
      
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || 'Attendance record created successfully'
      }
    } catch (error) {
      console.error('Error creating attendance:', error)
      
      // Re-throw the original error instead of returning a wrapped response
      // This preserves the original backend error message
      throw error
    }
  },

  // Update attendance record
  updateAttendance: async (attendanceId, updateData) => {
    try {
      console.log('Updating attendance record:', attendanceId, updateData)
      
      // Format the data according to API requirements
      const payload = {}
      if (updateData.clockIn !== undefined) payload.clockIn = updateData.clockIn
      if (updateData.clockOut !== undefined) payload.clockOut = updateData.clockOut
      if (updateData.status !== undefined) payload.status = updateData.status
      if (updateData.workingHours !== undefined) payload.workingHours = updateData.workingHours
      if (updateData.isLate !== undefined) payload.isLate = updateData.isLate
      
      const response = await api.patch(`/hr/attendance/${attendanceId}`, payload)
      
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || 'Attendance record updated successfully'
      }
    } catch (error) {
      console.error('Error updating attendance:', error)
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update attendance record',
        error: error.response?.data || error.message
      }
    }
  },

  // Delete attendance record
  deleteAttendance: async (attendanceId) => {
    try {
      console.log('Deleting attendance record:', attendanceId)
      const response = await api.delete(`/hr/attendance/${attendanceId}`)
      
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || 'Attendance record deleted successfully'
      }
    } catch (error) {
      console.error('Error deleting attendance:', error)
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete attendance record. Only absent attendance records can be deleted.',
        error: error.response?.data || error.message
      }
    }
  }
}

export default AttendanceService
